import React from "react";
import './SmallSpinner.css'

export const SmallSpinner = ({className}) => {
  return (
    <div className={`SmallSpinner lds-ellipsis-small ${className && className} `}><div></div><div></div><div></div><div></div></div>
  );
};
